// ===========================================
// The "already invoiced" prompt's list, for one host page
// ===========================================
// After an enrolment, the enrol route returns `alreadyInvoiced` (students enrolled into a term
// their family already holds a live invoice for). Hosts call `show(result.alreadyInvoiced)`; an
// empty list never opens anything. Kept with the browser history entry (`useHistoryEntryState`),
// so following an invoice link and pressing Back returns to the list (D-c); only Done clears it.

import { useCallback } from 'react';
import type { AlreadyInvoicedEnrolment } from '../api/lessons.api';
import { useHistoryEntryState } from './useHistoryEntryState';

const EMPTY: AlreadyInvoicedEnrolment[] = [];

export function useAlreadyInvoicedPrompt(name: string): {
  entries: AlreadyInvoicedEnrolment[];
  show: (entries: AlreadyInvoicedEnrolment[] | undefined | null) => void;
  clear: () => void;
} {
  const [entries, setEntries] = useHistoryEntryState<AlreadyInvoicedEnrolment[]>(name, EMPTY);
  const show = useCallback(
    (next: AlreadyInvoicedEnrolment[] | undefined | null) => {
      if (next && next.length > 0) setEntries(next);
    },
    [setEntries]
  );
  const clear = useCallback(() => setEntries(EMPTY), [setEntries]);
  return { entries, show, clear };
}
